import { Environment } from '../env';

/**
 * Full-width red banner marking non-production deployments (TEST / local dev).
 * Renders nothing on the real production backend (api.fitjo-app.link).
 */
export default function TestBanner() {
    if (Environment.IS_PROD) return null;
    return (
        <div
            style={{
                background: '#c0392b',
                color: '#ffffff',
                textAlign: 'center',
                fontWeight: 700,
                letterSpacing: '0.08em',
                padding: '6px 12px',
                fontSize: 14,
                position: 'sticky',
                top: 0,
                zIndex: 2000,
                width: '100%',
                textTransform: 'uppercase',
            }}
        >
            TESTUMGEBUNG!
        </div>
    );
}
